import React from 'react';

// Third-parties.

// Types.
import InstanaSnapshot from '../../types/integration/InstanaSnapshot';

// Contexts.
import { useTimeRange } from '../../context/TimeRangeContext';

function InstanaInstanceButton(props: { instanaSnapshots: InstanaSnapshot[] }) {
    const timeRangeContext = useTimeRange();
        
    

    return (
        props.instanaSnapshots.length > 0 ? (
            <button type="button" className="btn btn-heading stan" data-tooltip-id="global-tooltip" data-tooltip-content="View this instance in Instana" onClick={() => window.open(`${props.instanaSnapshots[0].url.replace('timeline.to=', `timeline.to=${timeRangeContext.timeRange.to.valueOf()}`).replace('timeline.fm=', `timeline.fm=${timeRangeContext.timeRange.from.valueOf()}`)}&timeline.ws=${timeRangeContext.timeRange.to.diff(timeRangeContext.timeRange.from, 'millisecond')}`, "_blank")}><i className="fak fa-stan fa-fw" aria-hidden="true"></i></button>
        ) : (
            <React.Fragment></React.Fragment>
        )
    );
}

export default InstanaInstanceButton;